// extracted by mini-css-extract-plugin
export default {"container":"kJ-z","header":"lJ-z","details":"mJ-z","link":"nJ-z"};